module.exports = __webpack_public_path__ + "static/img/shouchishenfenz@2x.5af5ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouchishenfenz@2x.png
// module id = 06TG
// module chunks = 4